var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreferenceIcon = function SvgPreferenceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 11.25h10.5a4.5 4.5 0 1 0 0-9H6.75a4.5 4.5 0 0 0 0 9m0-7.5h10.5a3 3 0 1 1 0 6H6.75a3 3 0 0 1 0-6m10.5 9H6.75a4.5 4.5 0 1 0 0 9h10.5a4.5 4.5 0 1 0 0-9m0 7.5H6.75a3 3 0 1 1 0-6h10.5a3 3 0 1 1 0 6m-12-13.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m13.5 10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  })));
};
export default SvgPreferenceIcon;